import { useMemo } from 'react';
import { TenderOffer } from 'types';

type UseBeneficiaryHasTenderOffersProps = {
  beneficiaryId: string;
  tenderOffers: TenderOffer[];
};

export const useBeneficiaryHasTenderOffers = ({
  beneficiaryId,
  tenderOffers,
}: UseBeneficiaryHasTenderOffersProps) => {
  const hasTenderOffers = useMemo(
    () =>
      tenderOffers.some((offer) =>
        offer.participants.some(
          (participant) => participant.id === beneficiaryId
        )
      ),
    [beneficiaryId, tenderOffers]
  );

  return {
    data: {
      hasTenderOffers,
    },
  };
};
